// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import SCCheckbox from '@/components/sc-controls/form-controls/sc-checkbox';
import Button from '@/components/button';
import { layout } from '@/theme';
import Fetch from '@/utils/Fetch';
import SettingsMenu from '@/components/settings/menu';
import * as Enums from '@/utils/enums';
import ToastContext from '@/utils/toast-context';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';
import SubscriptionContext from '@/utils/subscription-context';
import BillingService from '@/services/billing-service';
import ConfirmAccess from '@/components/modals/auth/confirm-access';
import SCUploadDropzone from '@/components/sc-controls/form-controls/sc-upload-dropzone';
import SCTextArea from '@/components/sc-controls/form-controls/sc-textarea';
import constants from '@/utils/constants';
import SCNumericInput from "@/components/sc-controls/form-controls/sc-numeric-input";
import companyService from '@/services/company-service';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'



function CreateStore() {

    const subscriptionContext = useContext(SubscriptionContext);
    const toast = useContext(ToastContext);

    let currPath = '';
    if (Router.router) {
        currPath = Router.router.asPath;
    }

    const [disableSave, setDisableSave] = useState(false);

    const [formIsDirty, setFormIsDirty] = useState(false);
    const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
    const [canAmendSubscription, setCanAmendSubscription] = useState(false);

    const getSubcriptionInfo = async () => {
        const [subscriptionInfo, _] = await BillingService.getSubcriptionInfo(subscriptionContext);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
            setCanAmendSubscription(subscriptionInfo.AccessStatus !== Enums.AccessStatus.Trial);
        }
    };

    useEffect(() => {
        getSubcriptionInfo();
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, submitStore);

    const { data: companyData } = useQuery(['company'], () => companyService.getCompany());

    // #region Store Settings

    const [name, setName] = useState('');

    const handleNameChange = (e: any) => {
        updateStore('Name', e.value);
        setName(e.value);
    };

    const [registeredName, setRegisteredName] = useState('');

    const handleRegisteredNameChange = (e: any) => {
        updateStore('RegisteredName', e.value);
        setRegisteredName(e.value);
    };

    const [code, setCode] = useState('');

    const handleCodeChange = (e: any) => {
        updateStore('Code', e.value);
        setCode(e.value);
    };

    const [addressLine1, setAddressLine1] = useState('');

    const handleAddressLine1Change = (e: any) => {
        updateStore('AddressLine1', e.value);
        setAddressLine1(e.value);
    };

    const [addressLine2, setAddressLine2] = useState('');

    const handleAddressLine2Change = (e: any) => {
        updateStore('AddressLine2', e.value);
        setAddressLine2(e.value);
    };

    const [addressLine3, setAddressLine3] = useState('');

    const handleAddressLine3Change = (e: any) => {
        updateStore('AddressLine3', e.value);
        setAddressLine3(e.value);
    };

    const [addressLine4, setAddressLine4] = useState('');

    const handleAddressLine4Change = (e: any) => {
        updateStore('AddressLine4', e.value);
        setAddressLine4(e.value);
    };

    const [postalLine1, setPostalLine1] = useState('');

    const handlePostalLine1Change = (e: any) => {
        updateStore('PostalLine1', e.value);
        setPostalLine1(e.value);
    };

    const [postalLine2, setPostalLine2] = useState('');

    const handlePostalLine2Change = (e: any) => {
        updateStore('PostalLine2', e.value);
        setPostalLine2(e.value);
    };

    const [postalLine3, setPostalLine3] = useState('');

    const handlePostalLine3Change = (e: any) => {
        updateStore('PostalLine3', e.value);
        setPostalLine3(e.value);
    };

    const [postalLine4, setPostalLine4] = useState('');

    const handlePostalLine4Change = (e: any) => {
        updateStore('PostalLine4', e.value);
        setPostalLine4(e.value);
    };

    const [telephone, setTelephone] = useState('');

    const handleTelephoneChange = (e: any) => {
        updateStore('TelephoneNumber', e.value);
        setTelephone(e.value);
    };

    const [fax, setFax] = useState('');

    const handleFaxChange = (e: any) => {
        updateStore('FaxNumber', e.value);
        setFax(e.value);
    };

    const [email, setEmail] = useState('');

    const handleEmailChange = (e: any) => {
        updateStore('EmailAddress', e.value);
        setEmail(e.value);
    };

    const [website, setWebsite] = useState('');

    const handleWebsiteChange = (e: any) => {
        updateStore('WebsiteAddress', e.value);
        setWebsite(e.value);
    };

    // #endregion

    // #region Email Settings

    const [emailFromName, setEmailFromName] = useState('');

    const handleEmailFromNameChange = (e: any) => {
        updateStore('EmailFromName', e.value);
        setEmailFromName(e.value);
    };

    const [emailFromAddress, setEmailFromAddress] = useState('');

    const handleEmailFromAddressChange = (e: any) => {
        updateStore('EmailFromAddress', e.value);
        setEmailFromAddress(e.value);
    };

    const [emailFromEmployee, setEmailFromEmployee] = useState(false);

    const handleEmailFromEmployeeChange = () => {
        let update = !emailFromEmployee;
        updateStore('EmailFromEmployee', update);
        setEmailFromEmployee(update);
    };

    // #endregion

    // #region Sales Order Settings

    const [taxPercentage, setTaxPercentage] = useState('');

    useEffect(() => {
      if (companyData?.TaxPercentage != null) {
        setTaxPercentage(companyData.TaxPercentage);
        setStore((prev: any) => ({ ...prev, TaxPercentage: companyData.TaxPercentage }));
      }
    }, [companyData]);

    const handleTaxPercentageChange = (e: any) => {
        updateStore('TaxPercentage', e.value);
        setTaxPercentage(e.value);
    };

    const [quoteExpiry, setQuoteExpiry] = useState('');

    const handleQuoteExpiryChange = (e: any) => {
        updateStore('QuoteExpiryPeriod', e.value);
        setQuoteExpiry(e.value);
    };

    const [invoiceDue, setInvoiceDue] = useState('');

    const handleInvoiceDueChange = (e: any) => {
        updateStore('InvoiceDuePeriod', e.value);
        setInvoiceDue(e.value);
    };

    const [jobTerms, setJobTerms] = useState<any>(null);

    const handleJobTermsChange = (e: any) => {
        updateStore('JobTerms', e.value);
        setJobTerms(e.value);
    };

    // #endregion

    const [inputErrors, setInputErrors] = useState<any>({});

    const validate = () => {

        let validationItems = [];
        validationItems = [
            { key: 'Name', value: name, required: true, type: Enums.ControlType.Text },
            { key: 'Code', value: code, required: true, type: Enums.ControlType.Text },
            { key: 'AddressLine1', value: addressLine1, required: true, type: Enums.ControlType.Text },
            { key: 'AddressLine2', value: addressLine2, required: true, type: Enums.ControlType.Text },
            { key: 'AddressLine3', value: addressLine3, required: true, type: Enums.ControlType.Text },
            { key: 'PostalLine1', value: postalLine1, required: true, type: Enums.ControlType.Text },
            { key: 'PostalLine2', value: postalLine2, required: true, type: Enums.ControlType.Text },
            { key: 'PostalLine3', value: postalLine3, required: true, type: Enums.ControlType.Text },
            { key: 'Telephone', value: telephone, required: true, type: Enums.ControlType.Text },
            { key: 'EmailFromName', value: emailFromName, required: true, type: Enums.ControlType.Text },
            { key: 'EmailFromAddress', value: emailFromAddress, required: true, type: Enums.ControlType.Email },
            { key: 'TaxPercentage', value: taxPercentage, required: true, type: Enums.ControlType.Number },
            { key: 'QuoteExpiry', value: quoteExpiry, required: true, type: Enums.ControlType.Number },
            { key: 'InvoiceDue', value: invoiceDue, required: true, type: Enums.ControlType.Number },
        ];

        const { isValid, errors } = Helper.validateInputs(validationItems);
        setInputErrors(errors);
        return isValid;
    };

    const [store, setStore] = useState({
        Name: '',
        RegisteredName: '',
        Code: '',
        AddressLine1: '',
        AddressLine2: '',
        AddressLine3: '',
        AddressLine4: '',
        PostalLine1: '',
        PostalLine2: '',
        PostalLine3: '',
        PostalLine4: '',
        TelephoneNumber: '',
        FaxNumber: '',
        EmailAddress: '',
        WebsiteAddress: '',
        VATRegistrationNo: '',
        CompanyRegistrationNumber: '',
        CustomField1: '',
        CustomField2: '',
        EmailFromName: '',
        EmailFromAddress: '',
        ReportLogo: '',
        CustomerNotify: '',
        QueryNotify: '',
        ProductNotify: '',
        JobCardNotify: '',
        CollectionNotify: '',
        InventoryNotify: '',
        QuoteNotify: '',
        InvoiceNotify: '',
        PrefixCustomer: '',
        PrefixInvoice: '',
        PrefixJobCard: '',
        PrefixProduct: '',
        PrefixQuery: '',
        PrefixQuote: '',
        BankAccountName: '',
        BankName: '',
        BankAccountNumber: '',
        BankBranchName: '',
        BankBranchCode: '',
        TaxPercentage: '',
        QuoteExpiryPeriod: '',
        InvoiceDuePeriod: '',
        QuoteComment: '',
        InvoiceComment: '',
        JobTerms: null
    });

    const updateStore = (field: any, value: any) => {
        let newStoreState = { ...store };
        newStoreState[field] = value;
        setFormIsDirty(true);
        setStore(newStoreState);
    };

    const [uploading, setUploading] = useState(false);

    const onUploadLogoChange = (e: any) => {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = async function () {
            let b64 = (reader.result as any).replace(/^data:.+;base64,/, '');
            setStore({ ...store, FileBase64: b64 });
        };
        reader.readAsDataURL(file);
    };

    async function submitStore() {
        setDisableSave(true);

        let isValid = validate();
        if (isValid) {

            if ((store as any).FileBase64) {
                setUploading(true);
            }

            const dataToPost = await Fetch.post({
                url: `/Store`,
                params: store,
                toastCtx: toast
            });

            if (dataToPost.ID) {
                Helper.mixpanelTrack(constants.mixPanelEvents.createStore, {
                    "storeID": dataToPost.ID
                });
                setFormIsDirty(false);
                await Helper.waitABit();
                Helper.nextRouter(Router.push, `/settings/store/list`);
            } else {
                toast.setToast!!!({
                    message: dataToPost.serverMessage,
                    show: true,
                    type: Enums.ToastType.error
                });
                setDisableSave(false);
            }

            setUploading(false);
        } else {
            toast.setToast!!!({
                message: 'There are errors on the page',
                show: true,
                type: Enums.ToastType.error
            });
            setDisableSave(false);
        }

        return isValid;
    }

    const [confirmEmployeeAccessOptions, setConfirmEmployeeAccessOptions] = useState({
        display: false,
        onConfirm: () => { },
        onCancel: () => { }
    });

    const confirmStorePopup = () => {

        let isValid = validate();

        if (!isValid) return;

        setConfirmEmployeeAccessOptions({
            display: true,
            onConfirm: () => {
                submitStore();
            },
        });
    };

    const cancel = () => {
        Helper.nextRouter(Router.push, '/settings/store/list');
    };

    return (
        <div className="settings-container">
            {/*<div className="row">
                <div className="title">
                    <Breadcrumbs
                        crumbs={[
                            { text: 'Settings', link: '', suppressLink: true },
                            { text: 'Stores', link: '/settings/store/list' },
                            { text: 'Create store', link: '/settings/store/create' },
                        ]}
                    />
                </div>
            </div>*/}
            <div className="row">
                <SettingsMenu urlPath={currPath} />
                <div className="settings-card">
                    <div className="row">
                        <div className="heading">Store settings</div>
                    </div>



                    <div className="row">
                        <div className="column">
                            <div className="row">
                                <div className="column">
                                    <SCInput
                                        name="Name"
                                        label="Name"
                                        onChange={handleNameChange}
                                        required={true}
                                        value={name}
                                        error={inputErrors.Name}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <SCInput
                                        name="RegisteredName"
                                        label="Registered name"
                                        onChange={handleRegisteredNameChange}
                                        value={registeredName}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <SCInput
                                        name="Code"
                                        label="Branch Code"
                                        onChange={handleCodeChange}
                                        required={true}
                                        value={code}
                                        error={inputErrors.Code}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <SCInput
                                        type={'tel'}
                                        name="TelephoneNumber"
                                        label="Telephone Number"
                                        onChange={handleTelephoneChange}
                                        required={true}
                                        value={telephone}
                                        error={inputErrors.Telephone}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <SCInput
                                        name="FaxNumber"
                                        label="Fax Number"
                                        onChange={handleFaxChange}
                                        value={fax}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <SCInput
                                        name="EmailAddress"
                                        label="Email Address"
                                        onChange={handleEmailChange}
                                        value={email}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <SCInput
                                        name="WebsiteAddress"
                                        label="Website Address"
                                        onChange={handleWebsiteChange}
                                        value={website}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="column column-center">
                            <br />
                            <SCUploadDropzone hint={`Add Logo`} note={`Drag and Drop file to Upload`} multiple={false}
                                onChange={onUploadLogoChange} dropzoneOverlaySrc={(store as any).LogoURL} fileType={Enums.FileType.Image} uploading={uploading} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="column">
                            <SCInput
                                name="AddressLine1"
                                label="Address Line 1"
                                onChange={handleAddressLine1Change}
                                required={true}
                                value={addressLine1}
                                error={inputErrors.AddressLine1}
                            />
                        </div>
                        <div className="column">
                            <SCInput
                                name="PostalLine1"
                                label="Postal Line 1"
                                onChange={handlePostalLine1Change}
                                required={true}
                                value={postalLine1}
                                error={inputErrors.PostalLine1}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCInput
                                name="AddressLine2"
                                label="Address Line 2"
                                onChange={handleAddressLine2Change}
                                required={true}
                                value={addressLine2}
                                error={inputErrors.AddressLine2}
                            />
                        </div>
                        <div className="column">
                            <SCInput
                                name="PostalLine2"
                                label="Postal Line 2"
                                onChange={handlePostalLine2Change}
                                required={true}
                                value={postalLine2}
                                error={inputErrors.PostalLine2}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCInput
                                name="AddressLine3"
                                label="Address Line 3"
                                onChange={handleAddressLine3Change}
                                required={true}
                                value={addressLine3}
                                error={inputErrors.AddressLine3}
                            />
                        </div>
                        <div className="column">
                            <SCInput
                                name="PostalLine3"
                                label="Postal Line 3"
                                onChange={handlePostalLine3Change}
                                required={true}
                                value={postalLine3}
                                error={inputErrors.PostalLine3}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCInput
                                name="AddressLine4"
                                label="Address Line 4"
                                onChange={handleAddressLine4Change}
                                value={addressLine4}
                            />
                        </div>
                        <div className="column">
                            <SCInput
                                name="PostalLine4"
                                label="Postal Line 4"
                                onChange={handlePostalLine4Change}
                                value={postalLine4}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="heading">Email settings</div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCInput
                                name="EmailFromName"
                                label="Reply to name"
                                onChange={handleEmailFromNameChange}
                                required={true}
                                value={emailFromName}
                                error={inputErrors.EmailFromName}
                            />
                        </div>
                        <div className="column">
                            <SCInput
                                name="EmailFromAddress"
                                label="Reply to address"
                                onChange={handleEmailFromAddressChange}
                                required={true}
                                value={emailFromAddress}
                                error={inputErrors.EmailFromAddress}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCCheckbox
                                name="EmailFromEmployee"
                                label="Reply to Employee"
                                onChange={handleEmailFromEmployeeChange}
                                value={emailFromEmployee}
                                hint='Only applicable Quotes, Invoices, Purchase Orders & Queries'
                            />
                        </div>
                        <div className="column"></div>
                    </div>
                    <div className="row">
                        <div className="heading">Sales order settings</div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCNumericInput
                                name="TaxPercentage"
                                label="Tax percentage"
                                onChange={handleTaxPercentageChange}
                                required={true}
                                min={0}
                                value={taxPercentage}
                                error={inputErrors.TaxPercentage}
                                format={Enums.NumericFormat.Percentage}
                                disabled={true}
                                hint='Edit Tax Percentage on Company Details'
                            />
                        </div>
                        <div className="column">
                            <SCNumericInput
                                name="QuoteExpiryPeriod"
                                label="Quote expiry period"
                                onChange={handleQuoteExpiryChange}
                                required={true}
                                format={Enums.NumericFormat.Integer}
                                value={quoteExpiry}
                                error={inputErrors.QuoteExpiry}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCNumericInput
                                name="InvoiceDuePeriod"
                                label="Invoice due period"
                                onChange={handleInvoiceDueChange}
                                required={true}
                                format={Enums.NumericFormat.Integer}
                                value={invoiceDue}
                                error={inputErrors.InvoiceDue}
                            />
                        </div>
                        <div className="column">
                        </div>
                    </div>
                    <div className="row">
                        <div className="heading">Job Settings</div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <SCTextArea
                                name="JobTerms"
                                label="Job Terms"
                                onChange={handleJobTermsChange}
                                value={jobTerms}
                            />
                        </div>
                        <div className="column">
                        </div>
                    </div>

                    <div className="row">
                        <div className="column">
                        </div>
                        <div className="column">
                            <div className="actions">
                                <Button text="Create" extraClasses="auto" onClick={canAmendSubscription ? confirmStorePopup : submitStore} disabled={disableSave} />
                                <Button text="Cancel" extraClasses="hollow auto" onClick={cancel} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

            <ConfirmAccess options={confirmEmployeeAccessOptions} setOptions={setConfirmEmployeeAccessOptions} module={"Store"} />

            <style jsx>{`
                .row {
                    display: flex;
                }
                .column {
                    display: flex;
                    flex-direction: column;
                    width: ${layout.inputWidth};
                }
                .column + .column {
                    margin-left: 1.25rem;
                }
                .actions {
                    display: flex;
                    flex-direction: row-reverse;
                }
                .actions :global(.button){
                    margin-left: 0.5rem;
                    margin-top: 1rem;
                    padding: 0 1rem;
                    white-space: nowrap;
                }
            `}</style>
        </div>
    );
}

export default CreateStore;

export const Route = createFileRoute('/_authenticated/settings/store/create')({ component: CreateStore })
